import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientesService } from 'src/app/services/clientes.service';
import { PaquetesService } from 'src/app/services/paquetes.service';
import { ProductosService } from 'src/app/services/productos.service';
import { environment } from '../../../environments/environment';
import { Ng2IzitoastService } from "ng2-izitoast";
import { CatalogosService } from 'src/app/services/catalogos.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { LoginService } from 'src/app/services/login.service';
import { GruposService } from 'src/app/services/grupos.service';

@Component({
  selector: 'app-detalle-paquete',
  templateUrl: './detalle-paquete.component.html',
  styleUrls: ['./detalle-paquete.component.scss']
})
export class DetallePaqueteComponent implements OnInit {
  environment = environment.BASE_URL

  datosCliente:any;
  clienteId;
  data;
  respuestaGetPerfil:any;
  perfil;
  anotaciones:any;
  respuestaGet:any;
  respuestaPagos:any;
  respuestaAgregarPagos:any;
  fechaPago = '';

  pagos;
  dataUsuario;
  totalPagos;
  totalCliente;
  saldo;
  usuarioid;
  datos_grupo;

  public preciosAnilloIds: number[] = [];
  public medidaAnillos: number[] = [];

  public boletos_adulto: number [] = [];
  public boletos_nino: number [] = [];

  respuestaMolduras: any;
  respuestaPlacas: any;
  respuestaPaquetes: any;
  respuestaDetallePaquete:any;
  respuestaAgregarPaqueteCliente:any;
  respuestaAgregarProductoCliente:any;
  respuestaDedicatorias:any;
  respuestaPaqueteCliente:any;
  respuestaAgregarPlaca:any;
  respuestaAgregarColor:any;
  respuestaAgregarMoldura:any;
  respuestaAgregarAnotaciones:any;
  respuestaColores:any;
  respuestaSolicitado:any;
  respuestaGuardar:any;
  respuestaViajes:any;
  respuestaAgregarViaje:any;
  respuestaFiestas:any;
  respuestaAgregarBoletosAdulto:any;
  respuestaAnillos:any;
  respuestaAgregarAnilloCliente:any;
  respuestaPrecioAnillos:any;
  respuestaProductos:any;
  dedicatorias:any;
  respuestaAgregar:any;
  respuestaFotos:any;
  anillos;
  viajes;
  fiestas;
  precioAnillos;
  solicitado = 0;
  dedicadoA;

  dedicatoriaPersonalizada;

  foto;
  fotos;
  molduras;
  placas;
  paquetesToChoose;
  detallePaquete;
  paqueteid;
  nombrePaquete;
  descripcion;
  paqueteImagen;
  paqueteCliente;
  clienteid;
  colores;
  productos;
  p
  boletos;
  observaciones;
  fondosMarcos;
  respuestaFondosMolduras:any;
  formularioPago;

  total = 1500;

  formulario;
  pagosSegmentados:any;
  pagosPorSegmento:any;


  constructor( private actRoute: ActivatedRoute, private _getPerfil:ClientesService,
    private _getMolduras: ClientesService, private _getPlacas: ClientesService, 
    private _getPaquetes: PaquetesService, private _getDetallePaquete: PaquetesService, private modalService: NgbModal,
    private _agregarPaqueteCliente: ClientesService, private _getProductos: ProductosService, 
    private _agregarMoldura: ClientesService, private _agregarPlaca: ClientesService, private _agregarColor: ClientesService,
    private _getColores:ClientesService,  private _agregarProductoCliente: ClientesService, 
    private _get:ProductosService, private _agregar:ClientesService,
    private _getFiestas:ClientesService, private _agregarBoletosAdulto: ClientesService, private _getAnillos:ClientesService,
    private _getViajes: ClientesService, private _agregarViaje:ClientesService,
    private _agregarAnotaciones: ClientesService, public iziToast: Ng2IzitoastService,
    private _agregarAnilloCliente:ClientesService, private _getAnotaciones:ClientesService,
    private _getPagos:ClientesService, private _agregarPago: ClientesService,
    private _grupos:GruposService,
    private _getFondosMolduras:CatalogosService, private _getData: LoginService, 
    private _agregarFoto: CatalogosService) { }

  ngOnInit(): void {
    this.actRoute.paramMap.subscribe(params => {
    this.clienteId = this.actRoute.snapshot.paramMap.get('cliente');
    this.clienteid = this.actRoute.snapshot.paramMap.get('cliente');
      if ( this.clienteId){
        this.getProfile(this.clienteId);
        this.getAnotaciones(this.clienteId);
        this.getPagos(this.clienteId);
      }
    });

    this.getPaquetes();
    this.getMolduras();
    this.getPlacas();
    this.getColores();
    this.getViajes();
    this.getFiestaGrupo();
    this.getAnillos();
    this.getPrecioAnillos();
    this.getProductos();
    this.getDedicatorias();
    this.getFondosMarcos();
    this.getDataCliente();
    this.getFotosCliente();


    this.boletos = {
      'adulto':'',
      'nino':'',
    }

    this.foto = {
      'nombre':'',
      'imagen':'',
    }

    this.formulario = {
      monto: '',
      usuarioid: '',
      forma_pago:'',
      tipo_pago:'',
      folio:'',
    }

    this.formularioPago = {
      tipo_pago: '',
    }

    this.dedicatoriaPersonalizada = {
      texto: '',
      dirigido:'',
    }

    this.anotaciones = {
      texto: '',
    }
  }

  getDataCliente(){
    this._getData.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
        
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }
 

  getProfile(cliente){
    this.data = {
      'usuario':cliente
    }
    this._getPerfil.getPerfil(this.data).subscribe(
      data => {
        this.respuestaGetPerfil = data;
        if(this.respuestaGetPerfil.success){
          this.perfil = this.respuestaGetPerfil.content;
          this.clienteId = this.perfil.id;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  getAnotaciones(cliente){
    this.data = {
      'usuario':cliente
    }
    this._getAnotaciones.getAnotaciones(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.observaciones = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  getFondosMarcos(){
    this._getFondosMolduras.getFondosMolduras().subscribe(
      data => {
        this.respuestaFondosMolduras = data;
        if(this.respuestaFondosMolduras.success){
          this.fondosMarcos = this.respuestaFondosMolduras.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getFotosCliente(){
    this.data ={
      'usuario': this.clienteId
    }
    this._getFondosMolduras.getFotosCliente(this.data).subscribe(
      data => {
        this.respuestaFotos = data;
        if(this.respuestaFotos.success){
          this.fotos = this.respuestaFotos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getDedicatorias(){
    this._get.getDedicatorias().subscribe(
      data => {
        this.respuestaDedicatorias = data;
        if(this.respuestaDedicatorias.success){
          this.dedicatorias = this.respuestaDedicatorias.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getProductos(){
    this._getProductos.getProductos().subscribe(
      data => {
        this.respuestaProductos = data;
        if(this.respuestaProductos.success){
          this.productos = this.respuestaProductos.content;
          console.log(this.productos);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }


  getColores(){
    this._getColores.getColores().subscribe(
      data => {
        this.respuestaColores = data;
        if(this.respuestaColores.success){
          this.colores = this.respuestaColores.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getMolduras(){
    this._getMolduras.getMolduras().subscribe(
      data => {
        this.respuestaMolduras = data;
        if(this.respuestaMolduras.success){
          this.molduras = this.respuestaMolduras.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPlacas(){
    this._getPlacas.getPlacas().subscribe(
      data => {
        this.respuestaPlacas = data;
        if(this.respuestaPlacas.success){
          this.placas = this.respuestaPlacas.content;
          console.log(this.placas);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getViajes(){
    this.data = {
      'cliente':this.clienteId
    }
    this._getViajes.getViajesGrupoCliente(this.data).subscribe(
      data => {
        this.respuestaViajes = data;
        if(this.respuestaViajes.success){
          this.viajes = this.respuestaViajes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPaquetes(){
    this._getPaquetes.getPaquetes().subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.paquetesToChoose = this.respuestaPaquetes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getFiestaGrupo(){
    this.data = {
      'cliente':this.clienteId
    }
    this._grupos.getFiestaGrupoCliente(this.data).subscribe(
      data => {
        this.respuestaFiestas = data;
        if(this.respuestaFiestas.success){
          this.fiestas = this.respuestaFiestas.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }
  // getFiestas(){
  //   this._getFiestas.getFiestas().subscribe(
  //     data => {
  //       this.respuestaFiestas = data;
  //       if(this.respuestaFiestas.success){
  //         this.fiestas = this.respuestaFiestas.content;
  //         for(var i=0; i<this.fiestas.length; i++){
  //           this.boletos_adulto[i] = 0;
  //           this.boletos_nino[i] = 0;
  //           // console.log(this.diasLaborados[i])
  //           // console.log(this.inasistencias[i])
  
  //         }

  //       }else {
  //         alert('No se cargaron los datos');
  //       }
  //     }, error => console.error(error));  
  // }

  getAnillos(){
    this._getAnillos.getAnillos().subscribe(
      data => {
        this.respuestaAnillos = data;
        if(this.respuestaAnillos.success){
          this.anillos = this.respuestaAnillos.content;
          this.inizializarPrecios();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  inizializarPrecios(){
    for(let ianillo of this.anillos){
      this.preciosAnilloIds.push(0);
      this.medidaAnillos.push(0);
    }
  }

  getPrecioAnillos(){
    this._getAnillos.getPrecioAnillos().subscribe(
      data => {
        this.respuestaPrecioAnillos = data;
        if(this.respuestaPrecioAnillos.success){
          this.precioAnillos = this.respuestaPrecioAnillos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  agregarProductoCliente(producto, cliente){
    this.data = {
        'producto':producto, 
        'cliente':cliente
    }

    this._agregarProductoCliente.agregarProductoCliente(this.data).subscribe(
      data => {
        this.respuestaAgregarProductoCliente = data;
        if(this.respuestaAgregarProductoCliente.success){
          this.dismissAll();
          window.location.reload();
          
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarFondoMolduraCliente(fondoMoldura, cliente){
    this.data = {
        'fondo_moldura':fondoMoldura, 
        'usuario':cliente
    }

    this._agregarProductoCliente.agregarFondoMolduraCliente(this.data).subscribe(
      data => {
        this.respuestaAgregarProductoCliente = data;
        if(this.respuestaAgregarProductoCliente.success){
          window.location.reload();
          
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }
    

  agregarDedicatoriaCliente(nombre, texto, dirigido, cliente){
    this.data = {
        'nombre':nombre, 
        'texto':texto, 
        'dirigido':dirigido, 
        'cliente':cliente
    }

    this._agregar.agregarDedicatoriaCliente(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.dismissAll();
          window.location.reload();
          
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }


  agregarPaqueteCliente(paquete, cliente){
    this.data = {
      'paquete':paquete, 
      'cliente':cliente
  }

  this._agregarPaqueteCliente.agregarPaqueteCliente(this.data).subscribe(
    data => {
      this.respuestaAgregarPaqueteCliente = data;
      if(this.respuestaAgregarPaqueteCliente.success){
        this.dismissAll();
        window.location.reload();
      }else {
        alert('No se cargaron los datos');
      }
    }, error => console.error(error)
  )
  }

  getDetallePaquete(paquete){
    this.data = {
      'paquete':paquete
    }

    this._getDetallePaquete.getDetallePaquete(this.data).subscribe(
      data => {
        this.respuestaDetallePaquete = data;
        if(this.respuestaDetallePaquete.success){
          this.detallePaquete = this.respuestaDetallePaquete.content;
          this.paqueteid = paquete;
          this.nombrePaquete = this.detallePaquete[0].paquete;
          this.descripcion = this.detallePaquete[0].descripcion;
          if (this.detallePaquete[0].imagen.length == 0){
            this.paqueteImagen = '/uploads/paquete/auri.png';
          }else{
            this.paqueteImagen = this.detallePaquete[0].imagen;
          }
          document.getElementById('clickPaquete').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarPlaca(placa, cliente){
    this.data = {
        'placa':placa, 
        'usuario':cliente
    }

    this._agregarPlaca.agregarPlacaUsuario(this.data).subscribe(
      data => {
        this.respuestaAgregarPlaca = data;
        if(this.respuestaAgregarPlaca.success){
          this.dismissAll();
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarColor(color, cliente){
    this.data = {
      'color':color, 
      'cliente':cliente
  }

    this._agregarColor.agregarColorUsuario(this.data).subscribe(
      data => {
        this.respuestaAgregarColor = data;
        if(this.respuestaAgregarColor.success){
          this.dismissAll();
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarMoldura(moldura, cliente){
    this.data = {
        'moldura':moldura, 
        'usuario':cliente
    }

    this._agregarMoldura.agregarMolduraUsuario(this.data).subscribe(
      data => {
        this.respuestaAgregarMoldura = data;
        if(this.respuestaAgregarMoldura.success){
          this.dismissAll();
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }


  agregarViaje(viaje, cliente){
    this.data = {
        'viaje':viaje, 
        'cliente':cliente
    }

    this._agregarViaje.agregarViajeCliente(this.data).subscribe(
      data => {
        this.respuestaAgregarViaje = data;
        if(this.respuestaAgregarViaje.success){
          this.dismissAll();
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarBoletosAdulto(cliente, fiesta, i){
    this.data = {
      'boletos_adulto':this.boletos_adulto[i], 
      'cliente':cliente,
      'fiesta':fiesta
  }

  this._agregarBoletosAdulto.agregarBoletosAdulto(this.data).subscribe(
    data => {
      this.respuestaAgregarBoletosAdulto = data;
      if(this.respuestaAgregarBoletosAdulto.success){
        this.dismissAll();
        window.location.reload();
      }else {
        alert('No se cargaron los datos');
      }
    }, error => console.error(error)
  )
  }


  agregarBoletosNino(cliente, fiesta, i){

    this.data = {
      'boletos_nino':this.boletos_nino[i], 
      'cliente':cliente,
      'fiesta':fiesta
  }
  

  this._agregarBoletosAdulto.agregarBoletosNino(this.data).subscribe(
    data => {
      this.respuestaAgregarBoletosAdulto = data;
      if(this.respuestaAgregarBoletosAdulto.success){
        this.dismissAll();
        window.location.reload();
      }else {
        alert('No se cargaron los datos');
      }
    }, error => console.error(error)
  )
  }

  agregarAnilloCliente(anillo, cliente, precioAnilloId, medidaAnillo){
    this.data = {
      'cliente':cliente,
      'anillo':anillo,
      'precioAnillo': precioAnilloId,
      'medidaAnillo': medidaAnillo,
  }
  
    this._agregarAnilloCliente.agregarAnilloCliente(this.data).subscribe(
      data => {
        this.respuestaAgregarAnilloCliente = data;
        if(this.respuestaAgregarAnilloCliente.success){
          this.dismissAll();
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarAnotaciones(cliente){
    this.data = {
      'texto': this.anotaciones.texto,
      'cliente':cliente,
      'usuario':this.datosCliente.id,
    }

    this._agregarAnotaciones.agregarAnotaciones(this.data).subscribe(
      data => {
        this.respuestaAgregarAnotaciones = data;
        if(this.respuestaAgregarAnotaciones.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado la anotación correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.anotaciones.texto = '';
          this.getAnotaciones(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPagos(idusuario){
    this.dataUsuario = {
      'usuario':idusuario
    }
    this._getPagos.getPagos(this.dataUsuario).subscribe(
      data => {
        this.respuestaPagos = data;
        if(this.respuestaPagos.success){
          this.pagos = this.respuestaPagos.content;
          this.totalPagos = this.respuestaPagos.total;
          this.totalCliente = this.respuestaPagos.compraMonto;
          this.saldo = this.respuestaPagos.saldo;
          this.usuarioid = this.respuestaPagos.usuarioid;
          this.datos_grupo = this.respuestaPagos.datos_pagos;
          this.pagosSegmentados = this.respuestaPagos.pagosSegmentados;
          this.pagosPorSegmento = this.respuestaPagos.pagosPorSegmento;
          document.getElementById('click').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarPago(dataid, forma_pago){
    if (this.formulario.fecha != null){
      this.fechaPago = this.formulario.fecha['year']+'-'+this.formulario.fecha['month']+'-'+this.formulario.fecha['day']
    }

    if(this.formulario.tipo_pago == ''){   
      this.iziToast.show(
        {
            title: 'Por favor selecciona un tipo de pago.',
            titleColor: '#f8f8ff',
            color: '#8B0000',
            position: 'topRight',
            closeOnEscape: true,
        });
        return;
    }

    if((this.formulario.monto == '') || (this.formulario.monto == undefined)){   
      this.iziToast.show(
        {
            title: 'Por favor ingresa monto de pago.',
            titleColor: '#f8f8ff',
            color: '#8B0000',
            position: 'topRight',
            closeOnEscape: true,
        });
        return;
    }

    if((this.formulario.folio == '') || (this.formulario.folio == undefined)){   
      this.iziToast.show(
        {
            title: 'Por favor ingresa folio de pago.',
            titleColor: '#f8f8ff',
            color: '#8B0000',
            position: 'topRight',
            closeOnEscape: true,
        });
        return;
    }

    if((this.formulario.forma_pago == '') || (this.formulario.forma_pago == undefined)){   
      this.iziToast.show(
        {
            title: 'Por favor ingresa folio de pago.',
            titleColor: '#f8f8ff',
            color: '#8B0000',
            position: 'topRight',
            closeOnEscape: true,
        });
        return;
    }

    this.data = {
      'pago': this.formulario.monto,
      'folio': this.formulario.folio,
      'forma_pago':this.formulario.forma_pago,
      'usuario': dataid,
      'tipo_pago':this.formulario.tipo_pago,
      'fecha':this.fechaPago,
    }

    this._agregarPago.agregarPago(this.data).subscribe(
      data => {
        this.respuestaAgregarPagos = data;
        if(this.respuestaPagos.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado el pago correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.formulario.folio = '';
          this.getPagos(dataid);
          this.getProfile(dataid);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updateEstatus(estatus, dataId){
    this.data = {
      'estatus':estatus,
      'usuario':dataId,
    }

    this._agregarPago.updateEstatus(this.data).subscribe(
      data => {
        this.respuestaAgregarPagos = data;
        if(this.respuestaPagos.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.getPagos(dataId);
          this.getProfile(dataId);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

  }

  eliminarPago(pago, dataId){

    this.data = {
      'pago':pago,
      'usuario':dataId,
    }

    this._agregarPago.eliminarPago(this.data).subscribe(
      data => {
        this.respuestaAgregarPagos = data;
        if(this.respuestaPagos.success){
          this.iziToast.show(
            {
                title: 'El pago se ha eliminado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getPagos(dataId);
          this.getProfile(dataId);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  desolicitarCliente(cliente:any){
    this.data = {
      'cliente':cliente
    }

    this._getPerfil.desolicitarCliente(this.data).subscribe(
      data => {
        this.respuestaGuardar = data;
        if(this.respuestaGuardar.success){
          this.getProfile(cliente);
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }


  imageChange(files: FileList){
    this.foto.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.foto.imagen.type.toString() == 'image/png' ||
        this.foto.imagen.type.toString() == 'image/jpeg' ) {
        if (this.foto.imagen.size > 10485760) {
          this.foto.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.foto.imagen);
    } else {
      this.foto.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  agregarFoto(){
    const formData = new FormData();
    formData.append('nombre', this.foto.nombre);
    formData.append('usuario', this.clienteId);
    if (this.foto.imagen){ 
      formData.append('imagen', this.foto.imagen);
    }

    this._agregarFoto.agregarFoto(formData).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getFotosCliente();
          this.foto.nombre = ''
          this.foto.imagen = null
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }
  
  public selectAnillo(anilloid: number): void {
    var anilloPrecioSelected = "precioAnillo"+anilloid;
  }

  eliminarFoto(foto){
    this.data = {
      'foto':foto,
    }

    this._agregarFoto.eliminarFoto(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha eliminado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getFotosCliente();
          this.foto.nombre = ''
          this.foto.imagen = null
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  descargarImagen(imagen){
    var xhr = new XMLHttpRequest();
    var url = this.environment+imagen
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function(){
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement('a');
        tag.href = imageUrl;
        tag.download = imagen;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
    }
    xhr.send();
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }
}
